import "./two_column_text_block.css";
